import { useSelector } from 'react-redux';
import partialRight from 'lodash/partialRight';
import { getIsFocusRequested } from '../redux/selectors';

export function useShouldFocus(editorId: string) {
  return useSelector(partialRight(getIsFocusRequested, editorId, false));
}
